function formatCents(amountNum: number, lang: string): string {
  const cents = amountNum * 100
  const formatter = new Intl.NumberFormat(lang, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
  const currencySymbol = lang === 'en-GB' ? 'p' : '¢'
  return `${formatter.format(cents)}${currencySymbol}`
}

function formatDollars(amountNum: number, lang: string): string {
  const formatter = new Intl.NumberFormat(lang, {
    style: 'currency',
    currency: lang === 'en-GB' ? 'GBP' : 'USD'
  })
  return formatter.format(amountNum)
}

export function formatCurrencyWithCents(
  amount: unknown,
  lang = 'en-US'
): string {
  const amountNum = Number(amount)
  return amountNum < 1
    ? formatCents(amountNum, lang)
    : formatDollars(amountNum, lang)
}
